import React from 'react'
import { Autocomplete, Box, Button, Card, IconButton, Input, Table, TextField, Typography } from '@mui/joy'
import { useState } from 'react'
import Checkbox from '@mui/material/Checkbox';
import { post, Token } from '../../../../Script/Session';
import { useNavigate } from 'react-router-dom';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { haspermission } from '../../../../Script/Permission';
function VergleichCreator({ data }) {
    const [selectedsparte, setselectedsparte] = useState();
    const [selectedsub, setselectedsub] = useState();
    const [subs, setsubs] = useState([]);
    const [subkathdata, setsubkathdata] = useState();
    const navigate = useNavigate();
    const [fragencheck, setfragencheck] = useState(new Map());
    const [allchecked, setallchecked] = useState(false);
    const [ergebnissarten, setergebnissarten] = useState(["PDF", "HTML"]);
    const [selectede, setselectede] = useState();
    const [tarifs, settarifs] = useState([]);
    const [selectedstände, setselectedstand] = useState(new Map());
    const [selectedleistungsübersicht, setselectedleistungsübersicht] = useState();
    const [leistungsübersichten, setleistungsübersichten] = useState([]);
    const [createleistungsübersicht, setcreateleistungsübersicht] = useState(false);
    const [leistungsübersichtname, setleistungsübersichtname] = useState();
    const [löffentlich, setlöffentlich] = useState(haspermission("30"));
    function handleleistungsübersichtchange(newv) {
        if (newv == null) {
            setselectedleistungsübersicht(null);
            return;
        }

        setallchecked(false);

        const updated = new Map();

        fragencheck.forEach((value, key) => {
            const isIncluded = Array.isArray(newv.fragen) && newv.fragen.includes(key);
            updated.set(key, isIncluded);
        });

        setfragencheck(updated);
        setselectedleistungsübersicht(newv);
    }
    const handlekathchange = (newv) => {
        setselectedsparte(newv);
        setsubs(newv.subkaths);
    }
    const handlesubkathchange = (newv) => {
        setselectedsub(newv);
    }
    function setsub() {
        if (!selectedsub) {
            return;
        }
        let body = {};
        body.token = Token.get();
        body.action = "get_tarifs";
        body.targetsubkath = selectedsub.id;
        let response = post(body, "/vergleichen");
        if (response == "LOGOUT") {
            navigate("/");
        }
        let a = new Map(fragencheck);
        const prased = JSON.parse(response);
        setsubkathdata(prased);
        prased.fragen
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((item, index) => {
                const keys = Object.keys(item).filter(k => k !== "order");
                const name = keys[0] || "Unbenannt";
                item[name]
                    .slice()
                    .sort((a, b) => a.order - b.order)
                    .map((frage, idx) => {

                        a.set(frage.name, false);


                    })
            })
        setfragencheck(a);
        setleistungsübersichten(prased.leistungsübersichten);
        console.log("Debug", prased.leistungsübersichten)
    }
    function generatebody() {
        let body = {};
        body.token = Token.get();
        body.action = "vergleichen";
        body.ids = tarifs;
        ///vergleichs_ergebniss/:body/:subkath
        let n = [];
        fragencheck.forEach((value, key) => {
            if (value) {
                n.push(key);
            }
        });
        console.log(selectedstände)
        let as = Object.fromEntries(
            Array.from(selectedstände.entries()).map(
                ([key, value]) => [key, value?.id]
            )
        );
        body.selstand = JSON.stringify(as);
        navigate("/vergleichs_ergebniss", {
            state: {
                body,
                subkathdata,
                tarifs,
                n,
                selectede
            }
        });


    }
    function cl(bool) {
        let body = {};
        body.token = Token.get();
        body.pub = bool;
        body.action = "create_leistungsübersicht";
        body.targetsubkath = selectedsub.id;
        body.name = leistungsübersichtname;
        let n = [];
        fragencheck.forEach((value, key) => {
            if (value) {
                n.push(key);
            }
        });
        body.fragenlist = n;
        let response = post(body, "/vergleichen");
        if (response == "LOGOUT") {
            navigate("/");
            return;
        }
        setsub();
        setcreateleistungsübersicht(false);
    }
    function updateleistungsübersicht() {
        let body = {};
        body.token = Token.get();
        body.action = "update_leistungsübersicht";
        body.name = selectedleistungsübersicht.name;
        body.targetsubkath = selectedsub.id;
        let n = [];
        fragencheck.forEach((value, key) => {
            if (value) {
                n.push(key);
            }
        });
        body.fragenlist = n;
        let response = post(body, "/vergleichen");
        if (response == "LOGOUT") {
            navigate("/");
            return;
        }
        setselectedleistungsübersicht(null);
        setsub();
    }
    function delleistungsübersicht() {
        let body = {};
        body.token = Token.get();
        body.action = "delete_leistungsübericht";
        body.name = selectedleistungsübersicht.name;
        body.targetsubkath = selectedsub.id;
        let response = post(body, "/vergleichen");
        if (response == "LOGOUT") {
            navigate("/");
            return;
        }
        window.location.reload();
    }
    if (createleistungsübersicht) {
        return (
            <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "row" }}>
                <Card sx={{ width: "100%" }}>
                    <Typography level="title-md">Namen festlegen</Typography>
                    <Input placeholder='Name' value={leistungsübersichtname} onChange={(e) => setleistungsübersichtname(e.target.value)} />
                    <Button onClick={() => cl(false)} sx={{ width: "10%" }}>Speichern</Button>
                    {
                        löffentlich && (
                            <Button sx={{ width: "10%" }} onClick={() => cl(true)}>Als Öffentlich speichern</Button>
                        )
                    }

                </Card>
            </Box>
        )
    }
    return (
        <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "row" }}>
            <Box sx={{ display: "flex", flexDirection: "column", width: "50%" }}>
                <Card variant='soft' sx={{ width: "95%" }}>
                    <Typography level="title-md">1.Tarif wählen</Typography>
                    <Autocomplete placeholder='Sparte' value={selectedsparte} onChange={(e, newv) => handlekathchange(newv)} options={data?.result} getOptionLabel={(i) => i.name} />
                    <Autocomplete placeholder='Untersparte' value={selectedsub} onChange={(e, newv) => handlesubkathchange(newv)} options={subs} getOptionLabel={(i) => i.name} />
                    <Button onClick={() => setsub()} sx={{ width: "15%" }}>
                        Setzen
                    </Button>
                </Card>
                <Card variant="soft" sx={{ width: "95%", mt: 2 }}>
                    <Box>
                        <Typography level="title-md">3. Tarife festlegen</Typography>
                        <Typography>Legen Sie fest, in welche Tarife verglichen werden</Typography>
                    </Box>
                    <Table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Stand</th>
                                <th>Entfernen</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tarifs.map((itemId) => {
                                const item = subkathdata?.tarifs.find((i) => i.id === itemId);
                             
                                return (

                                    <tr>
                                        <td>{item.name}</td>
                                        <td><Autocomplete
                                            value={selectedstände.get(item.id)}
                                            options={item.stände}
                                            getOptionLabel={(i) => i.name.split(" ")[0]}
                                            onChange={(event, newValue) => {
                                                const a = new Map(selectedstände);
                                                a.set(item.id, newValue);
                                                setselectedstand(a);
                                            }}
                                        /></td>
                                        <td><Button onClick={() => {


                                            settarifs((prev) => prev.filter((id) => id !== itemId));
                                        }} color='danger'>Entfernen</Button></td>
                                    </tr>
                                )

                            })}


                        </tbody>
                    </Table>



                    {
                        (tarifs.length < 4 || selectede != "PDF") && (
                            <Autocomplete
                                options={subkathdata?.tarifs || []}
                                onChange={(e, newval) => {
                                    if (!newval) return;
                                    let a = new Map(selectedstände);
                                    const item = subkathdata?.tarifs.find((i) => i.id === newval.id);
                                    a.set(newval.id, item.stände.find((b) => b.id == item.lasttarifid));
                                    setselectedstand(a);
                                    settarifs((prev) =>
                                        prev.includes(newval.id) ? prev : [...prev, newval.id]
                                    );
                                }}
                                getOptionLabel={(i) => i.ges + " " +  i.name + " (" + i.ftype + ")"}
                                renderInput={(params) => (
                                    <Box component="div" ref={params.InputProps.ref} {...params}>
                                        {params.inputProps.placeholder}
                                    </Box>
                                )}
                            />
                        )
                    }

                </Card>
                <Card variant='soft' sx={{ width: "95%", mt: 2 }} >
                    <Box>
                        <Typography level="title-md">4.Ergebniss festlegen</Typography>
                        <Typography>Legen sie fest in welcher form ihr Ergebniss angezeigt wird</Typography>
                    </Box>
                    <Autocomplete options={ergebnissarten} value={selectede} onChange={(e, newv) => setselectede(newv)} />
                    <Button onClick={() => generatebody()}>Ergebniss anzeigen</Button>
                </Card>
            </Box>
            <Box sx={{ width: "50%", overflowY: "auto", height: "100%" }}>
                <Card variant='soft' sx={{ height: "96%" }}>
                    <Box>
                        <Typography level="title-md">2.Bewertung wählen</Typography>
                        <Typography>Wählen sie die Fragen aus die sie für ihr Ergebniss berücksichtigen wollen</Typography>
                        <Typography>Wenn sie alle Fragen berücksichtigen wollen setzen sie den Haken bei alle</Typography>

                    </Box>
                    <Box>
                        <Typography level="title-sm">Gespeicherte Leistungsübersichten aufrufen</Typography>
                        <Typography>Im Folgender Maske können sie Gespeicherte fragen aufrufen und Verwalten</Typography>
                        <Typography color='danger'>Es werden immer nur der Sparte zugehörige Leistungsübersichten angezeigt</Typography>

                        <Autocomplete
                            value={selectedleistungsübersicht}
                            options={leistungsübersichten ?? []}
                            getOptionLabel={(i) => i.pub ? i.name + " (IGKV)" : i.name + " (Eigene)"}
                            placeholder='bei Bedarf hier Leistungsübersicht auswählen falls vorhanden'
                            onChange={(e, newv) => handleleistungsübersichtchange(newv)}
                            renderInput={(params) => <TextField {...params} label="Leistungsübersicht" />}
                        />
                        <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                            {selectedleistungsübersicht && selectedleistungsübersicht?.candelete ? (
                                <Button sx={{ mt: 2 }} onClick={() => updateleistungsübersicht()}>
                                    Leistungsübersicht Aktualisieren
                                </Button>
                            ) : !selectedleistungsübersicht ? (
                                <Button onClick={() => setcreateleistungsübersicht(true)} sx={{ mt: 2 }}>
                                    Auswahl als Leistungsübersicht Speichern
                                </Button>
                            ) : null}

                            {selectedleistungsübersicht && selectedleistungsübersicht?.candelete && (
                                <Button
                                    sx={{ mt: 2 }}
                                    onClick={() => delleistungsübersicht()}
                                    color="danger"
                                >
                                    Leistungsübersicht Löschen
                                </Button>
                            )}
                        </Box>

                    </Box>
                    <Table sx={{
                        bgcolor: "white",
                        '& td': {
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',

                        },
                    }}>
                        <thead>
                            <tr>
                                <th>Frage</th>
                                <th>Ausgewählt</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={"all"}>
                                <td>Alle Auswählen</td>
                                <td>
                                    <Checkbox value={allchecked} onChange={() => {
                                        const updatedMap = new Map(
                                            Array.from(fragencheck.entries()).map(([key, _]) => [key, !allchecked])
                                        );
                                        setfragencheck(updatedMap);
                                        setallchecked(!allchecked);
                                    }} />
                                </td>
                            </tr>
                            {Array.isArray(subkathdata?.fragen) &&
                                subkathdata?.fragen
                                    .slice()
                                    .sort((a, b) => a.order - b.order)
                                    .map((item, index) => {
                                        const keys = Object.keys(item).filter(k => k !== "order");
                                        const name = keys[0] || "Unbenannt";
                                        return (
                                            <React.Fragment key={`${index}-${name}`}>
                                                <tr>
                                                    <td colSpan={1} style={{ fontWeight: 'bold' }}>{name}</td>
                                                    <td />
                                                </tr>
                                                {Array.isArray(item[name]) &&
                                                    item[name]
                                                        .slice()
                                                        .sort((a, b) => a.order - b.order)
                                                        .map((frage, idx) => (
                                                            <tr key={`${index}-${idx}`}>
                                                                <td>{frage.name}</td>
                                                                <td> <Checkbox checked={fragencheck.get(frage.name)} onChange={() => {
                                                                    let a = new Map(fragencheck);
                                                                    a.set(frage.name, !a.get(frage.name));
                                                                    setfragencheck(a);
                                                                }} /></td>
                                                            </tr>
                                                        ))}
                                            </React.Fragment>
                                        );
                                    })}

                        </tbody>
                    </Table>

                </Card>


            </Box>




        </Box>
    )
}

export default VergleichCreator
